export default __webpack_public_path__ + "static/media/img_03.4ff49a10.jpg";